import styled from "styled-components";

import { Grid, FormControlLabel } from "@material-ui/core";

const opensans = (props) => props.theme.fonts.opensans;

export const HeaderAccordion = styled.div`
  width: 100%;
  .MuiChip-root {
    padding: 0;
    margin: 0;
    width: 100%;
  }
`;

export const Line = styled(Grid)`
  margin-bottom: 15px !important;
  margin-top: 5px !important;
`;

export const CheckItem = styled(FormControlLabel)`
  .MuiTypography-body1 {
    font-family: ${opensans}, "sans-serif";
  }
`;

export const Form = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  height: auto;
  width: 100%;
  padding: 10px;
`;
